import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const rectangleCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default rectangleCommands;
